import { render, staticRenderFns } from "./Viewfeemaster.vue?vue&type=template&id=56ef1c78&scoped=true"
import script from "./Viewfeemaster.vue?vue&type=script&lang=js"
export * from "./Viewfeemaster.vue?vue&type=script&lang=js"
import style0 from "./Viewfeemaster.vue?vue&type=style&index=0&id=56ef1c78&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56ef1c78",
  null
  
)

export default component.exports